module.exports = __webpack_public_path__ + "img/mc_z.23e9d107.png";